import { ContainerModule } from 'inversify';
import { KeywordSearchApi } from './repositories/apis/keyword-search-api.interface';
import { KeywordSearchRepository } from './repositories/keyword-search.repository.interface';
import { KeywordSearchService } from './services/keyword-search-service.interface';
import { KeywordSearchRepositoryImpl } from './repositories/keyword-search.repository';
import { KeywordSearchApiImpl } from './repositories/apis/keyword-search-api';
import { KeywordSearchServiceImpl } from './services/keyword-search-service';
export const keywordSearchModule = new ContainerModule(bind => {
    bind(KeywordSearchApi).to(KeywordSearchApiImpl);
    bind(KeywordSearchRepository).to(KeywordSearchRepositoryImpl);
    bind(KeywordSearchService).to(KeywordSearchServiceImpl);
});
